import classnames from "classnames";
import * as React from "react";
export default class WingBlank extends React.Component {
    render() {
        const { prefixCls, className, children, style } = this.props;
        const wrapCls = classnames(prefixCls, className);
        return (<div className={wrapCls} style={style}>
        {children}
      </div>);
    }
}
WingBlank.defaultProps = {
    prefixCls: "pm-wingblank",
};
